
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_LIST } from '../constants';
import { apiProvider } from '../api';
import { listMutationsNames } from './constants';


const filter = {
	ProvozovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	VyrazenPrp: null as boolean | null,
};

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_LIST,
	dropdownList: { ProvozovnaId: [] },
	filter,
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutationsNames.NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.filter.StrednaklOzn = data.value;
			state.filter.StrednaklOznText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: { },
		mode: null,
		afterRowSelection: () => {},
	},
});
